import { EventBus } from '@primeuix/utils/eventbus';

var TerminalService = EventBus();

export { TerminalService as default };
//# sourceMappingURL=index.mjs.map
